import React from 'react'
import Rodal from 'rodal'
import { useHistory } from "react-router-dom";

import { BackArrow } from './index'
import guest from 'src/images/guest.svg'

const StartTrialModal = ({ isOpen, onCancel, onSubmit }) => {

  const history = useHistory();

  const handleSubmit = () => {
    history.push('/r/signup');
    // onSubmit()
    // onCancel()
  }
  if (!isOpen) return null
  return (
    <Rodal
      width={430}
      height={340}
      showCloseButton={false}
      visible={isOpen}
      onClose={onCancel}
    >
      <div className="guest-modal">
        <BackArrow onClick={onCancel} />
        <div className="img-container">
          <img src={guest} alt="img" />
        </div>
        <br />
        <h1>Get started with POPin</h1>
        <p>
          Want to create your own sessions? Start a 14-Day Trial today! Use the live Help chat if you have questions on how it works.
        </p>
        <button onClick={handleSubmit} className="btn btn-submit">
          Sign Up Now
        </button>
      </div>
    </Rodal>
  );
}
export default StartTrialModal
